/* Landing header — background on scroll plus hide-on-scroll-down /
   show-on-scroll-up, matching the behaviour on wecanflyagency.com:
   the header only moves once the accumulated scroll in one direction
   passes ~10% of the viewport, so small jitter never flips it. */
class LandingHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-header-toggle]');
    this.scrollOffset = parseInt(this.dataset.scrollOffset || '100', 10);
    this.autoHide = this.dataset.autoHide !== 'false';
    this.lastScrollY = window.scrollY;
    this.accumulated = 0;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);

    this.drawer = document.getElementById('landing-menu');

    if (this.toggle) {
      this.toggle.addEventListener('click', () => this.setMenu(!this.isMenuOpen));
    }

    // Picking anything in the panel closes it: an in-page anchor never
    // navigates, so the panel would otherwise stay over the section it just
    // scrolled to, with the page still locked.
    if (this.drawer) {
      this.drawer.addEventListener('click', (event) => {
        // The language switcher's own button opens its list; closing the panel
        // there would make picking a language impossible.
        if (event.target.closest('.landing-locale__button')) return;
        if (event.target.closest('a, button:not([data-header-toggle])')) this.setMenu(false);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.isMenuOpen) this.setMenu(false);
    });

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.update();
  }

  get isMenuOpen() {
    return this.classList.contains('is-open');
  }

  setMenu(open) {
    this.classList.toggle('is-open', open);
    if (this.toggle) this.toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('menu-open', open);
    // An open drawer must never sit under a hidden header.
    if (open) this.classList.remove('is-hidden');
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    document.documentElement.classList.remove('menu-open');
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    const y = window.scrollY;
    const delta = y - this.lastScrollY;

    this.classList.toggle('is-scrolled', y > this.scrollOffset);

    if (this.autoHide && !this.classList.contains('is-open')) {
      this.accumulated += delta;
      const threshold = window.innerHeight * 0.1;

      if (Math.abs(this.accumulated) > threshold) {
        if (delta > 0 && y > this.scrollOffset) {
          this.classList.add('is-hidden');
        } else if (delta < 0) {
          this.classList.remove('is-hidden');
        }
        this.accumulated = 0;
      }
    }

    this.lastScrollY = y;
  }
}

if (!customElements.get('landing-header')) {
  customElements.define('landing-header', LandingHeader);
}
